/*@flow*/
import type { TypeT } from './types';

export default function options<V: {}, R: { [key: string]: any }>(
  x: TypeT<V>,
  o: R
): TypeT<V & { options: R }> {
  const meta = x.meta || {};
  const opts = meta.options || {};
  x.meta = { ...x.meta, options: { ...opts, ...o } };
  return (x: any);
}
